const messages = {
	ALINA_HUZ: 'Alina Huz',
	UI_UX_DESIGNER: 'UI/UX Designer',
	JUNIOR_UI_UX_DESIGNER: 'Junior UI/UX Designer',
	WEB_DESIGNER: 'Web Designer',
	BASED_IN_IRELAND: 'based in Ireland',
	HELLO: 'Hello!',
	MY_NAME_IS_ALINA_HUZ_AND_I: 'My name is Alina Huz and I',
	DESIGN_FOR_ME_IS:
		'Design for me is an interesting labyrinth with many' +
		" paths, where psychology and technology intertwine to ensure the achievement of the user's goals." +
		' And this labyrinth is definitely worth going through it.\n',
	I_WANT_TO_HELP:
		'I want to help change the world around me for the better and ' +
		'I firmly believe that UX/UI design is a great tool to do that. ' +
		'I believe that good experiences change lives and it is our role' +
		' to deliver the best brand experiences to users, converting' +
		' access into sales and building customer loyalty.',
	POSTER: 'poster',
	DRIBBBLE: 'dribbble',
	BEHANCE: 'behance',
	LINKEDIN: 'linkedin',
	SEE_MORE_WORKS: 'See more works',
	IF_YOU_WANT_YOU_CAN_FIND_MORE:
		'If you want, you can find more of my work' + ' on' + ' these' + ' resources',
	MAIN: 'Main',
	WORKS: 'works',
	ABOUT_ME: 'About me',
	ABOUT: 'About',
	SKILLS: 'Skills',
	EDUCATION: 'Education',
	EXPERIENCE: 'Experience',
	CONTACTS: 'Contacts',
	SELECTED_WORKS: 'Selected works',
	VIEW_CV: 'View CV',
	VIEW_PROJECT: 'View project',
	MAIL_ME: 'mail me',
	I_DECIDED_TO_BECOME_A_DESIGNER:
		'I decided to become a designer because I' +
		' wanted to have a creative' +
		' IT-related profession, to have a source for realizing my inspiration,' +
		' to be independent and mobile.\n',
	I_HAVE_A_PHARMACEUTICAL_EDUCATION:
		'I have a pharmaceutical education and I' +
		' even had success in' +
		' this' +
		' profession after devoting 3 years to it. But I quickly realized that' +
		' this job was not for me. I did not see myself as being able to have a' +
		' good career and develop as a person.\n',
	THE_DECISION_TO_CHANGE_CAREERS_CAME_EASILY:
		'The decision to change careers' +
		' came' +
		' easily to me, I had always been' +
		' a creative person, I had attended art school, I had an aptitude for' +
		' creating Power Point presentations, I even earned pocket money ' +
		'in college by creating presentations for my classmates because ' +
		'I was really good at it.\n' +
		'Lockdown due to Covid-19 pushed me to change my profession. And' +
		' I have never regretted that I made a choice in favor of design.',
	DUE_TO_THE_WAR_IN_MY_COUNTY:
		'Due to the war in my country, I had to flee' +
		' Ukraine in the' +
		' spring of 2022.     And at this stage of my life, I am in Ireland, and ' +
		'I am looking for a great job    for myself.',
	MY_MAIN_TOOL_IS_FIGMA_I_HAVE_A_HIGH_LEVEL:
		'My main tool is Figma. I have a high level of it and am constantly improving my skills. ' +
		'To work with bitmap images I use Adobe Photoshop. I can work in Adobe XD, but I prefer Figma to this tool. \n' +
		'I can do research, realization of personas, user flow maps, prediction of interaction scenarios. \n' +
		' I can create banners/animation banners, typographic logo designs, and low/high fidelity wireframes. \n' +
		'I have shown myself well in the ability to redesign. I have a basic understanding of HTML and CSS.' +
		' I use my skills to create a product that solves user problems and meets business goals.',
	I_HAVE_EXPERIENCE_DESIGNING_COMMERCE:
		'I have experience designing commerce and corporate websites, landing pages,' +
		' and portfolios while studying and working. In my work, I always try to follow trends, but not overdo it. \n' +
		'Reproduction of full-fledged visual design layouts taking into account typography, composition, ' +
		'color science, Gestalt principles, and understanding of UCD. \n' +
		'I have experience working in a team with developers and QA. In my work, I received information and ' +
		'presented my projects directly to the client (digital manager, owner).\n' +
		'I am not afraid of difficult tasks and always take them with passion as a challenge, and ' +
		'I am not afraid to ask a lot of questions.',
	RESPONSIBILITIES_AND_ACHIEVEMENTS: 'Responsibilities & Achievements',
	MAIN_RESPONSIBILITIES: 'Main responsibilities:',
	MAIN_ACHIEVEMENTS: 'Main achievements:',
	DEGREE: 'Degree',
	BERYSLAV_MEDICAL_COLLEGE: 'Beryslav Medical College',
	SECONDARY_VOCATIONAL_PHARMACY: 'Secondary vocational, Pharmacy/',
	SECONDARY_VOCATIONAL_DATE: 'sept. 2013 - June 2016',
	ENGLISH_LANGUAGE_DATE: 'sept. 2022 - Jun 2023',
	ZAPORIZHZHIA_STATE_MEDICAL_UNIVERSITY:
		'Zaporizhzhia State Medical' + ' University',
	LIMERICK_AND_CLARE_EDUCATION_AND_TRAINING_BOARD:
		'Limerick and Clare Education and Training Board',
	ENGLISH_LANGUAGE: 'English Language, Cambridge B2/',
	BACHELOR_PHARMACY: "Bachelor's degree, Pharmacy/",
	BACHELOR_PHARMACY_DATE: 'sept. 2016 - Jun 2018 ',
	ALL_RIGHTS_RESERVED: 'All rights reserved/',
	CERTIFICATE: 'certificate',
	IMPLEMENTATION: 'Implementation',
	SCROLL_TOP: 'Scroll top',
	SCROLL_DOWN: 'Scroll down',
	ERROR_CODE: '404',
	GO_TO_MAIN: 'Go to main',
	BLOCK: 'Block',
	CLICK: 'Click',
	OPENED_FULL_INFO: 'Opened full info',
	IM_SORRY_BUT_PAGE_NOT_AVAILABLE:
		"I'm sorry, but the page you requested is not available.",
	I_HAVE_A_GREAT_DESIRE_TO_DEVELOP:
		'I have a great desire to develop and' +
		' gain' +
		' experience in the field' +
		' of web design, work in a cool design studio or IT company,' +
		' so if you know or have any positions that I could apply for, feel free to connect with me.',
};

export default messages;
